class WorkStatus
  constructor: ->
    @_bind()

  _bind: ->
    $link = $('.link-member-work-status')
    $form = $('.form-member-work-status')
    $input = $('#member_name_card_attributes_comment')

    $link.on 'click', =>
      $link.parent().hide()
      $form.show()
      $input.focus().select()
      @_renderPopover()

    $('.link-member-work-status-clear').on 'click', @_hideInput

    $input.on 'keydown', (e) =>
      @_hideInput() if e.which == 27

    $form.on 'ajax:success', (e) =>
      if $input.val()
        $link.text $input.val()
      else
        $link.html('<span class="twr twr-pencil-square-o"></span> 填写工作签名')
      @_hideInput()

  _hideInput: ->
    $('.form-member-work-status').hide()
    $('.link-member-work-status').parent().show()
    simple.popover.destroyAll()

  _renderPopover: ->
    $form = $('.form-member-work-status')
    $input = $('#member_name_card_attributes_comment')
    popover = simple.popover
      pointTo: $input
      content: $('#tpl-member-work-status').html()
      position: 'bottom-right'
      cls: 'popover-member-work-status'
      align: 'left'
      offset:
        x: 23
        y: -8

    popover.el.on 'click', '.tpl-status', ->
      $input.val $(@).find('.tpl-status-name').text()
      popover.destroy()
      $form.submit()

tower.workStatus = ->
  new WorkStatus
